import React, { forwardRef } from 'react'
import { resolveActionProps } from './resolve-action-props'
import { useStateExpression } from './use-state-expression'

export const withResolvedProperties =
  ({
    actions = [],
    excludeProps = ['children'],
    onError,
  }: {
    actions?: string[]
    excludeProps?: string[]
    onError?: (error: unknown) => void
  }) =>
  (
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    Component: React.ComponentType<any>
  ): React.ComponentType<{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    [key: string]: any
  }> =>
    forwardRef((props, ref) => {
      const resolvedProps = useStateExpression(
        Object.fromEntries(
          Object.entries(props).filter(([k]) => !excludeProps.includes(k))
        ),
        {
          onError,
          before: (props, state, store) =>
            resolveActionProps({
              store,
              props,
              actions,
              state,
            }) as Record<string, unknown>,
        }
      )

      return <Component ref={ref} {...props} {...resolvedProps} />
    })
